import {extractProps} from '@famly/mf_ts-utils_extract-props';
import React from 'react';

export type TooltipRequiredProps = {
    onMouseOver: React.MouseEventHandler<HTMLSpanElement> | undefined;
    onMouseLeave: React.MouseEventHandler<HTMLSpanElement> | undefined;
    onFocus: React.FocusEventHandler<HTMLSpanElement> | undefined;
    onBlur: React.FocusEventHandler<HTMLSpanElement> | undefined;
    onTouchStart: React.TouchEventHandler<HTMLSpanElement> | undefined;
};

export function useTooltipRequiredProps<T extends {}>(props: T): Partial<TooltipRequiredProps> {
    return React.useMemo(
        () => extractProps<T, any>(props, ['onMouseOver', 'onMouseLeave', 'onFocus', 'onBlur', 'onTouchStart']),
        [props],
    );
}
